import PanelComponent from '../panel';

class FieldSetComponent extends PanelComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default FieldSetComponent;
